{
  "AGENT_MGMT": {
    "HEADER": "Agenti",
    "HEADER_BTN_TXT": "Dodaj agenta",
    "LOADING": "Preuzimanje liste agenata",
    "DESCRIPTION": "An agent is a member of your customer support team who can view and respond to user messages. The list below shows all the agents in your account.",
    "LEARN_MORE": "Learn about user roles",
    "AGENT_TYPES": {
      "ADMINISTRATOR": "Administrator",
      "AGENT": "Agent"
    },
    "COUNT": "{n} agent | {n} agents",
    "LIST": {
      "404": "Nema agenata povezanih sa ovim nalogom",
      "TITLE": "Upravljajte agentima u Vašem timu",
      "DESC": "Možete dodati ili ukloniti agente iz Vašeg tima.",
      "NAME": "Ime",
      "EMAIL": "E-POŠTA",
      "STATUS": "Status",
      "ACTIONS": "Akcije",
      "VERIFIED": "Provereno",
      "VERIFICATION_PENDING": "Verifikacija na čekanju",
      "AVAILABLE_CUSTOM_ROLE": "Available custom role permissions"
    },
    "ADD": {
      "TITLE": "Dodajte agenta u Vaš tim",
      "DESC": "Možete dodati ljude koji će moći da rukovode podrškom za vaše prijemno sanduče.",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "FORM": {
        "NAME": {
          "LABEL": "Ime agenta",
          "PLACEHOLDER": "Unesite ime agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Uloga",
          "PLACEHOLDER": "Izaberite ulogu",
          "ERROR": "Uloga je obavezna"
        },
        "EMAIL": {
          "LABEL": "E-mail adresa",
          "PLACEHOLDER": "Unesite e-mail adresu agenta"
        },
        "SUBMIT": "Dodaj agenta"
      },
      "API": {
        "SUCCESS_MESSAGE": "Agent je uspešno dodat",
        "EXIST_MESSAGE": "E-mail adresa agenta je već u upotrebi, pokušajte sa drugom e-mail adresom",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Agent je uspešno obrisan",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      },
      "CONFIRM": {
        "TITLE": "Potvrdite brisanje",
        "MESSAGE": "Sigurni ste da želite izbrisati ",
        "YES": "Da, izbriši ",
        "NO": "Ne, zadrži "
      }
    },
    "EDIT": {
      "TITLE": "Uredi agenta",
      "FORM": {
        "NAME": {
          "LABEL": "Ime agenta",
          "PLACEHOLDER": "Unesite ime agenta"
        },
        "AGENT_TYPE": {
          "LABEL": "Uloga",
          "PLACEHOLDER": "Izaberite ulogu",
          "ERROR": "Uloga je obavezna"
        },
        "EMAIL": {
          "LABEL": "E-mail adresa",
          "PLACEHOLDER": "Unesite e-mail adresu agenta"
        },
        "AGENT_AVAILABILITY": {
          "LABEL": "Dostupnost",
          "PLACEHOLDER": "Подведем итог",
          "ERROR": "Dostupnost je obavezna"
        },
        "SUBMIT": "Uredi agenta"
      },
      "BUTTON_TEXT": "Uredi",
      "CANCEL_BUTTON_TEXT": "Otkaži",
      "API": {
        "SUCCESS_MESSAGE": "Agent je uspešno ažuriran",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      },
      "PASSWORD_RESET": {
        "ADMIN_RESET_BUTTON": "Resetuj šifru",
        "ADMIN_SUCCESS_MESSAGE": "Agentu je poslana e-mail poruka sa instrukcijama za promenu šifre",
        "SUCCESS_MESSAGE": "Šifra agenta je uspešno promenjena",
        "ERROR_MESSAGE": "Nije moguće se povezati sa Woot serverom, pokušajte ponovo kasnije"
      }
    },
    "SEARCH_PLACEHOLDER": "Traži agente...",
    "NO_RESULTS": "No agents found matching your search",
    "SEARCH": {
      "NO_RESULTS": "Nema rezultata."
    },
    "MULTI_SELECTOR": {
      "PLACEHOLDER": "Nijedan",
      "TITLE": {
        "AGENT": "Izaberite agenta",
        "TEAM": "Izaberite tim"
      },
      "LIST": {
        "NONE": "Niko"
      },
      "SEARCH": {
        "NO_RESULTS": {
          "AGENT": "Nema pronađenih agenata",
          "TEAM": "Nema pronađenih timova"
        },
        "PLACEHOLDER": {
          "AGENT": "Traži agente",
          "TEAM": "Traži tim",
          "INPUT": "Поиск для агентов"
        }
      }
    }
  }
}
